import axios from 'axios';

export const GET_USERS_CLIENT_ACTIONS = '/usersClientActivitiesLog/getUserClientActivitiesLogs';
export const GET_USERS_CLIENT_ACTIONS_EXCEL = '/usersClientActivitiesLog/getUserClientActivitiesLogsForExcelFile';

export function getUsersClientActions(queryParams, cancellationHandlers) {
  return axios.get(GET_USERS_CLIENT_ACTIONS, {params: queryParams, ...cancellationHandlers});
}

export function getUsersClientActivitiesLogsForExcelFile(queryParams) {
  return axios.get(GET_USERS_CLIENT_ACTIONS_EXCEL, {params: queryParams});
}